import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import numeral from 'numeral';
import { useMemo } from 'react';
import { stockChange } from '../../../constants';
import { CompanySymbol, IconStockChange, SuspendedBadge } from '../../styled';

interface StockChangeWrapperProps {
  symbol: {
    symbol: string;
    change: string;
    price: string;
    percentage: number;
    status: string;
  };
}

function StockChangeWrapper({
  symbol: {
    symbol = '',
    change = '0',
    price = '0',
    percentage = 0,
    status = '',
  },
}: StockChangeWrapperProps) {
  const isCompanySuspended = status === 'STATUS_SUSPENDED';
  const isCompanyDelisted = status === 'STATUS_DELISTED';

  const numeralChange = useMemo(() => numeral(change), [change]);

  const priceType = useMemo(() => {
    if (numeralChange.value() > 0) return 'up';
    if (numeralChange.value() < 0) return 'down';
    return 'netral';
  }, [numeralChange]);

  const formattedPrice = useMemo(
    () => numeral(price).format('0,0.[00]'),
    [price],
  );

  const formattedChange = useMemo(() => {
    const val = numeralChange.value();
    if (Number.isNaN(val)) return 'NA';
    return numeralChange.format('0,0.00');
  }, [numeralChange]);

  const formattedPercentage = useMemo(() => {
    const val = numeralChange.value();
    if (val === 0) return '0.00%';
    return `${numeral(percentage).format('+0.00')}%`;
  }, [numeralChange]);

  return (
    <Flex align="center">
      <CompanySymbol valueType={stockChange[priceType].color}>
        <Text
          color={color.light}
          family="bold"
          size="18px"
          padding="3px 20px 0 8px"
        >
          {symbol}
        </Text>
      </CompanySymbol>

      {isCompanySuspended && (
        // @ts-expect-error
        <Flex pl="10px">
          <SuspendedBadge>
            <Text as="span" size="12px" color="inherit">
              Suspended
            </Text>
          </SuspendedBadge>
        </Flex>
      )}
      {isCompanyDelisted && (
        // @ts-expect-error
        <Flex pl="10px">
          <SuspendedBadge>
            <Text as="span" size="12px" color="inherit">
              Delisted
            </Text>
          </SuspendedBadge>
        </Flex>
      )}

      <Text family="bold" size="16px" padding="0 0 0 10px">
        {formattedPrice}
      </Text>
      <IconStockChange
        as="span"
        className={stockChange[priceType].icon}
        color={stockChange[priceType].color}
        hoverColor={stockChange[priceType].color}
      />
      <Text color={stockChange[priceType].color} padding="0 2px">
        {formattedChange}
      </Text>
      <Text color={stockChange[priceType].color} padding="0 2px">
        {formattedPercentage}
      </Text>
    </Flex>
  );
}

export default StockChangeWrapper;
